<template>
  <div class="assembly">
    <div class="m-left"><span></span> 选择组件</div>
    <div class="select">
      <div :class="['select-item',{'active':selectIndex == index}]" v-for="(item,index) in selectList" :key="index"
        @click="selectIndex = index">
        <div class="item-img">
          <img :src="item.url" alt="" draggable="true" @dragend="dragend_fn($event,index)">
        </div>
        <p>{{item.name}}</p>
      </div>

    </div>
    <div class="m-left"><span></span> 编辑属性</div>
    <!-- 选项卡表格 -->
    <div class="common" v-show="selectIndex == 0">
      <span>颜色：</span>
      <el-color-picker v-model="tabColor" show-alpha></el-color-picker>
    </div>
    <div class="tab-table" v-show="selectIndex == 0">
      <div class="tab-th tab-item">
        <div class="number">序号</div>
        <div class="tab-name">名称</div>
      </div>
      <div class="tab-td tab-item">
        <div class="number">1</div>
        <div class="tab-name">年</div>
      </div>
      <div class="tab-td tab-item">
        <div class="number">2</div>
        <div class="tab-name">月</div>
      </div>
      <div class="tab-td tab-item">
        <div class="number">3</div>
        <div class="tab-name">日</div>
      </div>
      <div class="tab-td tab-item">
        <div class="number"></div>
        <div class="tab-name"></div>
      </div>

      <div class="tab-add">
        +
      </div>
    </div>

    <!-- 全屏 -->
    <div class="weathers" v-show="selectIndex == 2">
      <div class="word">
        <span style="margin-right:10px">颜色</span>
        <el-color-picker v-model="screenColor" show-alpha @change="screen_fn(0)"></el-color-picker>
      </div>
    </div>

    <!-- 刷新 -->
    <div class="weathers" v-show="selectIndex == 3">
      <div class="word">
        <span style="margin-right:10px">颜色</span>
        <el-color-picker v-model="renovateColor" show-alpha @change="screen_fn(1)"></el-color-picker>
      </div>
    </div>

    <!-- 天气 -->
    <div class="weathers" v-show="selectIndex == 4">
      <div class="word">
        <span style="margin-right:10px">颜色</span>
        <el-color-picker v-model="weatherColor" show-alpha @change="weather_fn"></el-color-picker>
      </div>
      <div class="weather-check">
        <el-checkbox-group v-model="weatherCheckList" @change='weather_fn'>
          <el-checkbox label="天气类型"></el-checkbox>
          <el-checkbox label="温度"></el-checkbox>
          <el-checkbox label="风力"></el-checkbox>
          <el-checkbox label="湿度"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <!-- 日期 -->
    <div class="timers weathers" v-show="selectIndex == 5">
      <div class="word">
        <span style="margin-right:10px">颜色</span>
        <el-color-picker v-model="timerColor" show-alpha @change="timer_fn"></el-color-picker>
      </div>
      <div class="weather-check">
        <el-checkbox-group v-model="timerCheckList" @change='timer_fn'>
          <el-checkbox label="日期"></el-checkbox>
          <el-checkbox label="时间"></el-checkbox>
          <el-checkbox label="星期"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>


  </div>
</template>

<script>
  export default {
    props: ['weathObj','trimerObj'],
    data () {
      return {
        //组件数据
        selectList: [
          {
            'name': "选项卡",
            'url': require('@/assets/customKanBan/assembly/tab.png'),
          },
          {
            'name': "下拉菜单",
            'url': require('@/assets/customKanBan/assembly/select.png'),
          },
          {
            'name': "全屏",
            'url': require('@/assets/customKanBan/assembly/fullscreen.png'),
          },
          {
            'name': "刷新",
            'url': require('@/assets/customKanBan/assembly/renovate.png'),
          },
          {
            'name': "天气",
            'url': require('@/assets/customKanBan/assembly/weather.png'),
          },
          {
            'name': "时间",
            'url': require('@/assets/customKanBan/assembly/time.png'),
          },
        ],
        //组件选中
        selectIndex: 4,
        //选项卡颜色
        tabColor: "#21416C",
        //全屏
        screenColor: "#fff",
        //刷新
        renovateColor: "#fff",
        //天气
        weatherColor: "#fff",
        weatherCheckList: ['天气类型','温度','风力','湿度'],
        //日期
        timerColor: "#fff",
        timerCheckList: ['日期','时间','星期'],

      };
    },

    mounted () {

    },
    watch: {
      weathObj (val) {
        if(JSON.stringify(val)=="{}") {
          return
        }

        this.selectIndex=val.type
        this.weatherColor=val.info.color
        this.weatherCheckList=val.weatherCheckList
      },
      trimerObj (val) {
        if(JSON.stringify(val)=="{}") {
          return
        }
        this.selectIndex=val.type
        this.timerColor=val.info.color
        this.timerCheckList=val.timerCheckList
      },

    },

    methods: {
      //拖放
      dragend_fn (e,index) {
        var clientX=e.clientX
        var clientY=e.clientY
        var d={
          'clientX': clientX,
          'clientY': clientY,
          'type': index,
          'tabIndex': 2,
        }
        if(index==2) {
          d.color=this.screenColor
        }
        if(index==3) {
          d.color=this.renovateColor
        }
        if(index==4) {
          d.color=this.weatherColor
          d.weatherCheckList=['天气类型','温度','风力','湿度']
        }
        if(index==5) {
          d.color=this.timerColor
          d.timerCheckList=['日期','时间','星期']
        }
        console.log("参数",d);
        this.$emit('assembly_fn',d)
      },
      //全屏跟刷新样式
      screen_fn (val) {
        var color=""
        if(val==0) {
          color=this.screenColor
        } else {
          color=this.renovateColor
        }
        var d={
          'color': color,
          'type': val
        }
        this.$emit('screens_fn',d)

      },
      //全屏跟刷新样式变化
      screenChange (index,val) {
        this.selectIndex=val.type
        if(index==0) {
          this.screenColor=val.info.color
        } else {
          this.renovateColor=val.info.color
        }
      },
      //天气样式
      weather_fn () {
        var d={
          'color': this.weatherColor,
          'weatherCheckList': this.weatherCheckList,
        }
        this.$emit('weathers_fn',d)
      },
      //时间样式
      timer_fn () {
        var d={
          'color': this.timerColor,
          'timerCheckList': this.timerCheckList,
        }
        this.$emit('timers_fn',d)
      },


    },
  };
</script>

<style lang="scss" scoped>
  .assembly {
    .m-left {
      color: #359EFF;
      display: flex;
      align-items: center;

      span {
        background-color: #359EFF;
        display: inline-block;
        width: 2px;
        height: 12px;
        margin-right: 4px;

      }
    }

    .select {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 40px;

      .select-item {
        width: 31%;
        height: 100px;
        background-color: #000000;
        margin-top: 15px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        transition: all 0.3s;
        border: 2px solid transparent;

        .item-img {
          width: 95%;
          height: 68px;
          margin-top: 5px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            max-width: 95%;
          }

        }

        &.active {
          border: 2px solid #0085FF;

        }

        &:hover {
          /* 鼠标悬浮时盒子出现的阴影 */
          //    box-shadow: 0px 1px 12px 0px #cccccc;
          transform: translate(0, -5px);
          /* 鼠标悬浮时盒子上移10px */
        }

        p {
          color: #999999;
        }
      }
    }

    .common {
      display: flex;
      align-items: center;
      margin: 20px 0px;
    }

    .tab-table {
      width: 250px;
      background-color: #000000;
      position: relative;

      .tab-item {
        width: 100%;
        height: 44px;
        border-bottom: 1px solid #999999;
        display: flex;

        .number {
          width: 90px;
          text-align: center;
          line-height: 44px;
          color: #999999;
          border-right: 1px solid #999999;

        }

        .tab-name {
          width: 160px;
          line-height: 44px;
          color: #999999;
          margin-left: 12px;
        }
      }

      .tab-td {

        .number,
        .tab-name {
          color: #ffffff;
        }
      }

      .tab-add {
        position: absolute;
        right: -36px;
        bottom: 0px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background-color: #359EFF;
        text-align: center;
        line-height: 24px;
        color: #ffffff;
        font-size: 24px;
        cursor: pointer;
      }
    }

    .weathers {
      .word {
        display: flex;
        align-items: center;
        margin: 20px 0px;
      }

      /deep/.el-checkbox {
        margin-right: 20px;
      }

      /deep/.el-checkbox__input {
        top: -1px;
      }

      /deep/.el-checkbox__label {
        padding-left: 6px;
      }
    }



  }
</style>